import { render, staticRenderFns } from "./ListSwitch.vue?vue&type=template&id=67130d9e"
import script from "./ListSwitch.vue?vue&type=script&lang=js"
export * from "./ListSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports